<template>
  <div class="form-wrapper">
    <h1>Rest Contest Attempt</h1>
    <form class="add-user-to-cohort" @submit.prevent="updateUserContestAttempt">
      <label for="user-id">User ID</label>
      <input
        id="user-id"
        v-model="userID"
        class="p-3 border"
        autofocus
        placeholder="Enter user id or email"
        required
        type="text"
      />
      <label for="cohort-id">Select Contest</label>
      <VueSelect
        label="name"
        :reduce="contest => contest.name"
        :options="contestList"
        @input="setContestID"
      />
      <button
        class="button-green link border p-3 px-12 rounded-full bg-green text-white font-bold m-1"
        type="submit"
      >
        Reset attempt
      </button>
    </form>
  </div>
</template>

<script>
import VueSelect from "vue-select"
import siteConfig from "@/utils/siteConfig"

export default {
  components: { VueSelect },
  data() {
    return {
      userID: undefined,
      contestList: [],
      contestID: undefined,
    }
  },
  mounted() {
    this.axios({
      method: "get",
      url: `${siteConfig.siteURL}assignments/?type=contest&fetch_active_contests=1`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-access-token": localStorage.token,
      },
    }).then(res => {
      this.contestList = res.data.items
    })
  },
  methods: {
    setContestID(contest) {
      this.contestID = contest ? contest.id : undefined
    },
    updateUserContestAttempt() {
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}admin/user_contest/${this.userID}/${this.contestID}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(() => {
          this.$noty.success("successfully reset contest attempt")
        })
        .catch(() => {
          this.$noty.error("failed to reset contest attempt")
        })
    },
  },
}
</script>

<style scoped>
.form-wrapper {
  max-width: 500px;
  margin: auto;
  margin-top: 80px;
}
input,
textarea,
select {
  display: block;
  width: 100%;
  margin: auto;
  padding: 10px;
  border-radius: 5px;
  font-size: 16px;
  /* text-align: center; */
}
textarea {
  height: 150px;
}
label {
  display: block;
  padding: 10px 0px;
  font-size: 16px;
  text-align: left;
}
</style>
